import React, { createContext, useCallback } from 'react';
import { TrackGoogleEventUseCase } from '../../application/use_cases/analytics/TrackGoogleEventUseCase';
import { GoogleTagEventKeys } from '../../config/GoogleTagEventKeys';

interface GoogleTagProviderProps {
  useCase: TrackGoogleEventUseCase;
  children: React.ReactNode;
}

const GoogleTrackEventsContext = createContext<TrackGoogleEventUseCase | null>(
  new TrackGoogleEventUseCase(new GoogleTagEventKeys())
);

export const GoogleTrackEventsProvider: React.FC<GoogleTagProviderProps> = ({
  useCase,
  children
}) => {
  return (
    <GoogleTrackEventsContext.Provider value={useCase}>
      {children}
    </GoogleTrackEventsContext.Provider>
  );
};

export const useTrackGoogleEvents = () => {
  const context = React.useContext(GoogleTrackEventsContext);

  if (!context) {
    throw new Error('useGoogleTag must be used within a GoogleTagProvider');
  }

  const trackDisplayOffer = useCallback(() => {
    return context.trackDisplayOffer();
  }, [context]);

  const trackSubmitOrder = useCallback(() => {
    return context.trackSubmitOrder();
  }, [context]);

  const trackSubmitOffer = useCallback(() => {
    return context.trackSubmitOffer();
  }, [context]);

  const trackEnterOnboarding = useCallback(() => {
    return context.trackEnterOnboarding();
  }, [context]);

  return {
    trackDisplayOffer,
    trackSubmitOrder,
    trackSubmitOffer,
    trackEnterOnboarding
  };
};
